import { PhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import * as EmailValidator from 'email-validator'
import { ParsedPhoneNumber } from '@/utils/locator'
import {countries} from "@/utils/countries";

// validates the given email address
const validate_email = (email: string) : boolean => {
  return EmailValidator.validate(email)
}

// validates the given phone number
const validate_phone = (dial?: string, no?: string): ParsedPhoneNumber|undefined => {
  if (!no) { return  }
  // parse phone number
  let parsed: PhoneNumber

  if (!dial) {
    parsed = parsePhoneNumber('+'+no) as PhoneNumber
  } else {
    parsed = parsePhoneNumber(dial + no) as PhoneNumber
  }

  // nil
  if (!parsed) { return }
  if (!parsed.isValid()) { return }

  // format number
  const formatted = parsed.formatInternational()

  if (!dial) {
    dial = countries[parsed.country as string].dial_code
  }


  return {
    dial:      dial,
    number:    parsed.nationalNumber,
    formatted: formatted,
    country:   parsed.country as string
  }
}

export {
  validate_email, validate_phone
}

